import { SideDrawer } from '@theme/side-drawer';

/**
 * Size Guide Drawer - extends SideDrawer base class
 * Includes unit conversion logic (IN ↔ CM)
 */
class SizeGuideDrawer extends SideDrawer {
  connectedCallback() {
    super.connectedCallback();
    /** @type {NodeListOf<HTMLButtonElement>} */
    this.unitToggles = this.querySelectorAll('.size-guide-dialog__unit-btn');
    this.unitToggles.forEach(toggle => {
      toggle.addEventListener('click', this.#handleUnitToggle);
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.unitToggles?.forEach(toggle => {
      toggle.removeEventListener('click', this.#handleUnitToggle);
    });
  }

  /**
   * @param {Event} event
   */
  #handleUnitToggle = (event) => {
    const button = /** @type {HTMLButtonElement} */ (event.currentTarget);
    const unit = button.dataset.unit;

    this.unitToggles.forEach(t => t.classList.remove('active'));
    button.classList.add('active');

    this.#convertUnits(unit);
  };

  /**
   * @param {string | undefined} unit
   */
  #convertUnits(unit) {
    /** @type {NodeListOf<HTMLElement>} */
    const values = this.querySelectorAll('.size-guide-table__value[data-original]');
    values.forEach(cell => {
      const original = parseFloat(cell.dataset.original || '0');
      cell.textContent = unit === 'cm' 
        ? (original * 2.54).toFixed(1) 
        : cell.dataset.original || '';
    });
  }
}

if (!customElements.get('size-guide-drawer')) {
  customElements.define('size-guide-drawer', SizeGuideDrawer);
}
